import { useState } from 'react';
import { Field, FieldLabel, FormField, FormModal, FormRow, SearchSelect, Select, TextArea } from '../../components';
import { useCreateTicket } from '../../queries/maintenance';
import { useVendorOptions } from '../../queries/vendors';
import { TIER_OPTIONS } from '../../utils/maintenance';

const EMPTY = { propertyUnit: '', issue: '', tier: 'standard', vendorId: '', scheduledFor: '', notes: '' };

export default function TicketFormModal({ initial, onClose }) {
  const [form, setForm] = useState({ ...EMPTY, ...initial });
  const create = useCreateTicket();
  const { data: vendors = [] } = useVendorOptions();
  const valid = Boolean(form.propertyUnit.trim() && form.issue.trim());

  const set = (key) => (e) => setForm((f) => ({ ...f, [key]: e.target.value }));

  const save = () => {
    create.mutate(
      {
        ...form,
        propertyUnit: form.propertyUnit.trim(),
        issue: form.issue.trim(),
        status: form.vendorId ? 'scheduled' : 'new',
        scheduledFor: form.scheduledFor ? new Date(form.scheduledFor).toISOString() : null
      },
      { onSuccess: onClose }
    );
  };

  return (
    <FormModal
      title="New ticket"
      subtitle="Log a repair or service request"
      okText="Create ticket"
      valid={valid}
      loading={create.isPending}
      onSubmit={save}
      onClose={onClose}
    >
        <FormField>
          <FieldLabel htmlFor="ticket-unit">Property / unit</FieldLabel>
          <Field id="ticket-unit" required autoFocus placeholder="214 Magnolia Ct, Unit B" value={form.propertyUnit} onChange={set('propertyUnit')} />
        </FormField>
        <FormField>
          <FieldLabel htmlFor="ticket-issue">Issue</FieldLabel>
          <Field id="ticket-issue" required placeholder="What needs fixing?" value={form.issue} onChange={set('issue')} />
        </FormField>
        <FormRow>
          <FormField>
            <FieldLabel htmlFor="ticket-new-tier">Tier</FieldLabel>
            <Select id="ticket-new-tier" style={{ minWidth: 0 }} value={form.tier} onChange={set('tier')}>
              {TIER_OPTIONS.map((o) => (
                <option key={o.value} value={o.value}>
                  {o.label}
                </option>
              ))}
            </Select>
          </FormField>
          <FormField>
            <FieldLabel htmlFor="ticket-new-vendor">Vendor</FieldLabel>
            <SearchSelect
              id="ticket-new-vendor"
              allowClear
              placeholder="Unassigned"
              value={form.vendorId}
              onChange={(v) => setForm((f) => ({ ...f, vendorId: v }))}
              options={vendors.map((v) => ({ value: v._id, label: v.company }))}
            />
          </FormField>
        </FormRow>
        <FormField>
          <FieldLabel htmlFor="ticket-new-date">Scheduled for</FieldLabel>
          <Field id="ticket-new-date" type="datetime-local" value={form.scheduledFor} onChange={set('scheduledFor')} />
        </FormField>
        <FormField>
          <FieldLabel htmlFor="ticket-new-notes">Notes</FieldLabel>
          <TextArea id="ticket-new-notes" placeholder="Access details, tenant availability…" value={form.notes} onChange={set('notes')} />
        </FormField>
    </FormModal>
  );
}
